export default "__VITE_ASSET__BR0h4CTd__"